import styled from '@emotion/styled'
import { tokens } from '../../theme.js'
const colors = tokens.colors
const borderRadius = tokens.borderRadius

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.gap || tokens.spacing.control};
  width: ${p => p.width || 'auto'};
`
export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${p => p.align || 'center'};
  gap: ${p => p.gap || tokens.spacing.control};
`
export const WhiteCard = styled.div`
  background: ${colors.background.white};
  border-radius: ${borderRadius.div};
  padding: ${p => p.padding || tokens.spacing.section};
`
